import React, { useEffect, useState, useContext } from 'react';
import CardContainer from '../../components/CardContainer';
import { useAuth } from '../../contexts/AuthContext';
import LoadingContext from '../../contexts/LoadingContext';
import api from '../../service/api';

import './styles.css';

function ListarTenants(){
  const { jwt, signOut } = useAuth();
  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if(error.message === 'Request failed with status code 401'){
      signOut();
    }else{
      return error;
    }
  });

  if(jwt) api.defaults.headers = { 'Authorization': `Bearer ${jwt}` }

  const {changeLoadingState} = useContext(LoadingContext);
  const [listaImobiliarias, setListaImobiliarias] = useState([]);
  const [listaImobiliariasFiltrada, setListaImobiliariasFiltrada] = useState([]);

  const [codigoBusca, setCodigoBusca] = useState('');
  const [filtroAmbiente, setFiltroAmbiente] = useState('PROD');

  useEffect(() => {
    async function getImobiliarias(){
      changeLoadingState(true);
      try{
        const {data} = await api.get('/imobiliarias/PROD');
        setListaImobiliarias(data);
        setListaImobiliariasFiltrada(data);
        changeLoadingState(false);
      }catch(e){
        console.log(e);
        changeLoadingState(false);
      }
    }
    
    getImobiliarias();
    // eslint-disable-next-line
  },[]);

  useEffect(() => {
    if(codigoBusca) {
      const busca = listaImobiliarias.filter((imob:any) => imob.codigo.includes(codigoBusca));
      setListaImobiliariasFiltrada(busca); 
    }else{
      setListaImobiliariasFiltrada(listaImobiliarias);
    }
    // eslint-disable-next-line
  },[listaImobiliarias]);

  function onBuscaChange(e: React.ChangeEvent<HTMLInputElement>){
    const {value} = e.target;
    const valorFinal = value.replace(/\D/g,'');
    if(value && !valorFinal) return;
    if(!valorFinal) {
      setListaImobiliariasFiltrada(listaImobiliarias);      
    }else{
      const busca = listaImobiliarias.filter((imob:any) => imob.codigo.includes(valorFinal));
      setListaImobiliariasFiltrada(busca);      
    }
    setCodigoBusca(valorFinal);
  }
  
  async function onAmbienteChange(e: React.ChangeEvent<HTMLSelectElement>){
    const {value} = e.target;
    try{
      changeLoadingState(true);
      const {data} = await api.get('/imobiliarias/'+value);
      setListaImobiliarias(data);
      setFiltroAmbiente(value);
      changeLoadingState(false);
    }catch(e){
      console.log(e);
      changeLoadingState(false);
    }    
  }

  return (
    <div className="container">
      <div className="filtros-container">
        <div>
          <label htmlFor="busca-codigo">Filtrar por código</label><br />
          <input type="text" id="busca-codigo" value={codigoBusca} onChange={e => onBuscaChange(e)} />
        </div>
        <div>
          <label htmlFor="ambiente">Ambiente</label><br />
          <select id="ambiente" value={filtroAmbiente} onChange={e => onAmbienteChange(e)} >
            <option value="PROD">Produção</option>
            <option value="AMBIENTE_TESTE">Ambiente de teste</option>
          </select>
        </div>
      </div>
      <CardContainer listaImobiliariasFiltrada={listaImobiliariasFiltrada} ambiente={filtroAmbiente} />
    </div>
  );
}

export default ListarTenants;